export const LAB_TEST_SIDES = ['L', 'R', 'Both'];

export function labTestDisplayName(testName, side) {
  if (!testName) return testName || '';
  if (!LAB_TEST_SIDES.includes(side)) return testName;
  return `${testName} (${side})`;
}
